// Widget Scripts
import customTicketButton from './js/widgets/customTicketButton.js';
import slideshow from './js/widgets/slideshow.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import masonryCardsDouble from './js/widgets/masonryCardsDouble.js';
import seoWidget from './js/widgets/seoWidget.js';
import cardWidgetMap from './js/widgets/cardWidgetMap.js';
import multipleCustomSponsors from './js/widgets/multipleCustomSponsors.js';
import photoGallery from './js/widgets/photoGallery.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  customTicketButton();
  if (globalThis.location.pathname === '/') {
    slideshow();
    multiScheduleFeature();
    masonryCardsDouble('masonryCardsDoubleLarge', masonryCardsDoubleLargeOpts, 2);
    masonryCardsDouble('masonryCardsDoubleSmall', masonryCardsDoubleSmallOpts, 4);
    seoWidget();
    cardWidgetMap();
    multipleCustomSponsors('scrollerSponsors', scrollerSponsorsOpts);
    multipleCustomSponsors('staticSponsors', staticSponsorsOpts);
    photoGallery();
  }
});
